import { Settings01Icon } from '@langchain/untitled-ui-icons';
import { ButtonTypeMap } from '@mui/joy/Button';

import { Dispatch, SetStateAction, useState } from 'react';

import { IconButton } from '@/design-system';
import { HostProjectSchema } from '@/types/schema.ts';

import { HostProjectSettingsModal } from './HostProjectSettingsModal';

export function HostProjectSettingsModalWithButton(props: {
  buttonProps?: ButtonTypeMap['props'];
  hostProject: HostProjectSchema;
  deploymentPlatformId: string;
  customHeaders: Record<string, string>;
  setCustomHeaders: Dispatch<SetStateAction<Record<string, string>>>;
}) {
  const [open, setIsOpen] = useState(false);
  return (
    <>
      <IconButton
        variant="plain"
        color="secondary"
        onClick={() => setIsOpen(true)}
        icon={Settings01Icon}
        label="Deployment Settings"
      />
      {open && (
        <HostProjectSettingsModal
          hostProject={props.hostProject}
          deploymentPlatformId={props.deploymentPlatformId}
          isOpen={open}
          doClose={() => setIsOpen(false)}
          customHeaders={props.customHeaders}
          setCustomHeaders={props.setCustomHeaders}
        />
      )}
    </>
  );
}
